import { UserDropdown } from 'components/dropdown/UserDropdown';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const UserSelectionHeading = styled.div`
    font-size: 2rem;
    font-weight: normal;
    margin-left: 2rem;
`;

export const SelectedUserDropdown = styled(UserDropdown)`
    padding: 0;
    color: ${tokens.text.link};
    min-width: 15rem;
    white-space: nowrap;
    overflow: hidden;
    max-width: 80rem;
`;

export const SearchCreateContainer = styled.div`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;

    @media ${MediaQueries.smallAndDown} {
        margin: 1rem 0rem;
    }
`;
